import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from '../select-next';
import { PossibleSuffixes } from './possible-suffixes';

const SuffixNextOld = props => {
  const { 'data-cv-test': dataCvTest, scrollTag } = props;

  return (
    <BaseSelect
      label="Suffix (optional)"
      name="suffix"
      options={PossibleSuffixes}
      transparent
      disabledStateValue={{ value: 'default', label: 'Select Suffix' }}
      data-cv-test="suffix"
      {...props}
      data-cv-test-override={dataCvTest || 'nameSuffix'}
      canContainEmptyDefaultValue
      scrollTag={scrollTag}
    />
  );
};

SuffixNextOld.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string,
  scrollTag: PropTypes.string
};

SuffixNextOld.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': 'suffix',
  scrollTag: null
};

export default SuffixNextOld;
